import { EMAIL_REGEX } from '@constants';
import { t } from 'i18next';

export const RULES = {
  REQUIRED: { required: true, message: t('DefaultTranslations:REQUIRED_FIELD') },
  EMAIL: {
    validator: (_: unknown, value: string) => {
      if (!value) {
        return Promise.resolve();
      }

      const isValid = EMAIL_REGEX.test(value);
      return isValid
        ? Promise.resolve()
        : Promise.reject(new Error(t('DefaultTranslations:INVALID_EMAIL_FORMAT')));
    }
  },
  URL: { type: 'url', message: t('DefaultTranslations:WRONG_FORMAT_URL') }
};
